<template>
    <v-row justify="center">
        <v-dialog v-model="ModalChatDialog" fullscreen hide-overlay transition="dialog-bottom-transition" persistent>
            <v-menu v-model="showmenu_copy_img" :position-x="x_copy_img" :position-y="y_copy_img" absolute offset-y>
                  <v-list>
                    <v-list-item @click="doCopyImage(ModalChatDetail.message)">
                      <v-list-item-title>{{ $t('ChatSide.RightClickMenu.copy-all') }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
            <v-card>
                <v-toolbar dark color="#000000d4" style="height: 50px !important;">
                    <v-spacer></v-spacer>
                    <v-toolbar-title>{{ room_name }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn icon dark @click="closeDialog()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-toolbar dense elevation="0" flat color="#00000000">
                    <v-row class="justify-center align-center">
                        <v-col cols="2" align="center">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn @click="downloadFile(ModalChatDetail.typeofmessage === 'video' || ModalChatDetail.typeofmessage === 'audio' ? ModalChatDetail.original_file : ModalChatDetail.message, ModalChatDetail.file_name)" v-bind="attrs" v-on="on" color="white" dark small icon class="mr-5"
                                    :loading="loadingFile" :disabled="loadingFile">
                                        <v-icon dark>fa-solid fa-download</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ $t('AnswerQuestion.download') }}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn :disabled="ModalChatDetail.typeofmessage === 'video'" @click="openDialog(ModalChatDetail)" v-bind="attrs" v-on="on" color="white" dark small icon class="mr-3">
                                    <v-icon dark>fa-solid fa-upload</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ $t('AnswerQuestion.sendOnebox') }}</span>
                            </v-tooltip>                            
                        </v-col>
                        <v-col cols="8" align="center">
                            <p class="mb-0 text-name">{{ ModalChatDetail.nickname }}</p>
                            <p class="mb-0 color-white">{{ dateMoment(ModalChatDetail.timestamp) }} | {{ timeMoment(ModalChatDetail.timestamp) }}</p>
                        </v-col>
                        <v-col cols="2" align="end"></v-col>
                    </v-row>
                </v-toolbar>
                <v-row v-if="progress" class="justify-center align-center" style="height: 80vh;">
                    <v-progress-circular indeterminate color="white" size="80" width="8"></v-progress-circular>
                </v-row>
                <v-row class="justify-center align-center" v-else style="height: 80vh; margin-top: 10px;">
                    <p style="display: none;">{{ ModalChatDetail.typeofmessage }}</p>
                    <img v-if="ModalChatDetail.typeofmessage === 'image'" :src="ModalChatDetail.message" :alt="ModalChatDetail.file_name" class="image" @contextmenu="showMenuImage">
                    <video-player v-else-if="ModalChatDetail.typeofmessage === 'video'" class="video-js" :options="videoOptions" :poster="thumbnail_video" ref="myPlayer" :sources="sources_video" />
                    <vue-pdf-app v-else-if="ModalChatDetail.typeofmessage === 'file'" :pdf="ModalChatDetail.message" style="height: 80vh; width: 90%;" :page-number="1"></vue-pdf-app>
                </v-row>
            </v-card>
            <v-snackbar
                v-model="snackbarCopy"
                :timeout="2000"
                top
                absolute
                text
                color="#2463af"
                >
                    <span style="text-align: center; justify-content: center; display: flex;">{{$t('Alert.Chat.copyImage')}}</span>
            </v-snackbar>
        </v-dialog>
        <SaveToOnebox :tokenuser="tokenuser" :SaveToOneboxDialog="SaveToOneboxDialog" :SaveToOneboxDetail="SaveToOneboxDetail" @closeComponents="closeComponents"></SaveToOnebox>
    </v-row>
</template>
<script>
import { Momenttime } from '@/services';
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";
import SaveToOnebox from './SaveToOnebox.vue';
import {
	copyImageToClipboard
} from 'copy-image-clipboard'
export default {
    props: {
        ModalChatDialog: Boolean,
        ModalChatDetail: Object,
        room_name: String,
        tokenuser: String,
    },
    components: {
        VuePdfApp,
        SaveToOnebox
    },
    data() {
        return {
            showmenu_copy_img: false,
            x_copy_img: 0,
            y_copy_img: 0,
            snackbarCopy: false,
            progress: true,
            loadingFile: false,
            thumbnail_video: '',
            videoOptions: {
                autoplay: false,
                controls: true,
                muted: true
            },
            sources_video: [],
            SaveToOneboxDialog: false,
            SaveToOneboxDetail: {},
        }
    },
    watch: {
        ModalChatDialog() {
            if (this.ModalChatDialog) {
                // console.log("ModalChatDialog =>", this.ModalChatDetail);
                var me = this;
                me.progress = true;
                setTimeout(() => {
                    if (me.ModalChatDetail.typeofmessage === 'video') {
                    me.thumbnail_video = me.ModalChatDetail.thumbnail;
                    me.sources_video = [me.ModalChatDetail.message];
                    // console.log("this.sources_video => ", me.sources_video);
                } else {
                    me.thumbnail_video = "";
                    me.sources_video = [];
                }
                me.progress = false;
                }, 2000);
            }
        },
    },
    created() {
        console.log("created modal");
    },
    methods: {
        showMenuImage(e) {
            e.preventDefault()
            this.showMenu = false
            this.x_copy_img = e.clientX
            this.y_copy_img = e.clientY
            this.$nextTick(() => {
                this.showmenu_copy_img = true
            })
        },
        async doCopyImage(url) {
			// console.log("doCopyImage =>", url);
			var me = this
			copyImageToClipboard(url).then(() => {
				// console.log('Image Copied')
				me.snackbarCopy = true
				})
				.catch((e) => {
				console.log('Error: ', e.message)
				})
		},
        closeComponents(item) {
            if (item.name === 'onebox') {
                this.SaveToOneboxDetail = {};
                this.SaveToOneboxDialog = item.value;
            }
        },
        closeDialog() {
            this.progress = false;
            this.$emit('closeComponents', {
                name: 'modal-chat',
                value: false,
            })
        },
        dateMoment (time) {
            if (time !== undefined) {
                return Momenttime.dayjsdatethai(time)
            }
        },
        timeMoment (time) {
            if (time !== undefined) {
                return Momenttime.dayjstimethai(time)
            }
        },
        openDialog (item) {
            this.SaveToOneboxDetail = item;
            this.SaveToOneboxDialog = true;
        },
        downloadFile(file, name) {
            // console.log("file =>", file);
            this.loadingFile = true
            this.axios.get(file, {
                responseType: 'blob'
            }).then((response) => {
                this.loadingFile = false
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', name)
                document.body.appendChild(link)
                link.click()
            }).catch((err) => {
                console.log(err.response);
                this.loadingFile = false
            })
        },
    },
}
</script>
<style scoped>
>>>.v-dialog--fullscreen {
    border-radius: 0;
    margin: 0;
    height: 100%;
    position: fixed;
    overflow-y: hidden !important;
    top: 0;
    left: 0;
}
>>>.video-js {
  display: block;
  vertical-align: top;
  box-sizing: border-box;
  color: #fff;
  background-color: #000;
  position: relative;
  padding: 0;
  font-size: 10px;
  line-height: 1;
  font-weight: 400;
  font-style: normal;
  font-family: Arial,Helvetica,sans-serif;
  word-break: initial;
  width: 70% !important;
  height: 80% !important;
}

.image {
    margin: auto;
    display: block;
    max-width: 80%;
    max-height: 70%;
}
.text-name {
    color: white;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 50em;
    font-weight: 500;
    white-space: nowrap;
}
.color-white {
    color: white;
}
>>>.v-toolbar__content {
    height: 50px !important;
}
>>>.theme--light.v-card {
    background-color: #000000d4 !important;
    color: rgba(0, 0, 0, .87) !important;
}
</style>